import React from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { PinUnpinVideoDecorated } from 'components/video-box/common/pin-unpin-video';
import { DownloadVideo } from 'components/video-box';
import { viewRangeSelector, withReportVideoSelector } from 'common/selectors';
import { VideoShareDropdownDecorated } from 'components/context-menu/video-share-dropdown';
import { VideoContextMenuDecorated } from 'components/video-context-menu';

const Component = connect((state) => ({
  withReportVideo: withReportVideoSelector(state),
  viewRange: viewRangeSelector(state),
}))(({ video }) => (
  <React.Fragment>
    <DownloadVideo video={video} />
    <PinUnpinVideoDecorated video={video} />
    <VideoShareDropdownDecorated />
    <VideoContextMenuDecorated video={video} testPrefix="home-page-" />
  </React.Fragment>
));

export const VideoControlsMenu = ({ video }) => <Component video={video} />;

VideoControlsMenu.propTypes = {
  video: PropTypes.object.isRequired,
};
